module.exports = __webpack_public_path__ + "img/tecnologia.a3f03302.jpg";